<template>
  <div class="tags">
    <h1 class="title">Cloud Tags</h1>
    <div class="tag-box">
      <el-skeleton :rows="5" animated :loading="isLoading" style="margin-top:100px" />
      <el-tag class="tag" :key="t.id" v-for="t in tags" :type="randomTagType()" @click="toThisTag(t)">
        <i class="icon el-icon-collection-tag" /><span class="name">{{t.tagName}} ({{t.quantityUsed}})</span>
      </el-tag>
      <!-- <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">Spring (34)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">博客 (1)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">希望 (99)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">聊天 (12)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">美女 (30)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">帅哥 (2)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">MybatisPlus (1)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">黑客 (5)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">SpringSpring (99+)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">小嘬 (123)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">Spring (34)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">博客 (1)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">希望 (99)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">聊天 (12)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">美女 (30)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">帅哥 (2)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">MybatisPlus (1)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">黑客 (5)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">SpringSpring (99+)</span></el-tag><el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">小嘬 (123)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">Spring (34)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">博客 (1)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">希望 (99)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">聊天 (12)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">美女 (30)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">帅哥 (2)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">MybatisPlus (1)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">黑客 (5)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">SpringSpring (99+)</span></el-tag><el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">小嘬 (123)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">Spring (34)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">博客 (1)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">希望 (99)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">聊天 (12)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">美女 (30)</span></el-tag>
        <el-tag class="tag" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">帅哥 (2)</span></el-tag> -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import { AssertGoodResponse, getRandomFromArr } from '@/util/GlobalUtil'
import { useGetRequest } from '@/hooks'
import { useRouter } from 'vue-router'
import { BlogConditionStrategies } from '@/interfaces'

export default defineComponent({
  setup() {
    // State
    const router = useRouter()
    const state = reactive({
      isLoading: true,
      tags: [],
    })
    const randomTagType = () =>
      getRandomFromArr(['info', '', 'danger', 'warning', 'success'])
    // 调接口,获取所有Tag
    useGetRequest('/api/tag').then((res) => {
      AssertGoodResponse(res)
      state.tags = res.data.data
      state.isLoading = false
    })

    // 跳转到conditon页面, 查看当前类型下的所有博客
    // eslint-disable-next-line
    const toThisTag = (tag: any) => {
      router.push({
        name: 'ConditionBlogs',
        params: {
          conditionStrategy: BlogConditionStrategies.BY_TAG,
          value: tag.id
        },
        query:{
          conditionStrategy: BlogConditionStrategies.BY_TAG,
          value: tag.id
        }
      })
    }

    return {
      ...toRefs(state),
      randomTagType,
      toThisTag,
    }
  },
})
</script>

<style lang="scss" scoped>
.tags {
  .tag-box {
    margin-top: 30px;
    .tag {
      cursor: pointer;
      margin: 0 10px 15px 10px;
      transition: all 0.3s;
      .name {
        margin-left: 5px;
      }

      &:hover {
        transform: scale(1.1);
      }
    }
  }
}
</style>